<template>
  <svg
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6436 0.427734H12.3044C12.2133 0.427734 12.1276 0.472377 12.074 0.545592L7.00078 7.53845L1.92757 0.545592C1.874 0.472377 1.78828 0.427734 1.69721 0.427734H0.357927C0.241856 0.427734 0.173998 0.559877 0.241856 0.65452L6.53828 9.33488C6.76686 9.64916 7.23471 9.64916 7.4615 9.33488L13.7579 0.65452C13.8276 0.559877 13.7597 0.427734 13.6436 0.427734Z"
      :fill="color"
    />
  </svg>
</template>

<script>
import IconBase from "./IconBase.vue";
export default {
  mixins: [IconBase],
};
</script>



// WEBPACK FOOTER //
// Down.vue?42899f36